import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles({
  btn: {
    transition: 'all 0.3s ease-in-out',
    height: 40,
    borderRadius: 10,
    fontSize: 16,
    lineHeight: 1.4,
    textAlign: 'center',
    color: '#fff',
    padding: '5px 20px',
    boxSizing: 'border-box',
    '&:focus': {
      outline: 'none',
    },
    '&:disabled': {
      border: '1px solid rgba(0, 0, 0, 0.12)',
    },
  },
});

export default function MyButton({ children, className, ...rest }) {
  const cls = useStyles();
  return (
    <Button
      className={clsx(cls.btn, className)}
      variant="contained"
      disableElevation
      {...rest}>
      {children}
    </Button>
  );
}
